(() => {
const root=document.getElementById('ig-everyday-fix');
if(!root||root.dataset.initialized)return;
root.dataset.initialized='true';
const labels=JSON.parse(root.querySelector('[data-fix-labels]').textContent);
const panels=[...root.querySelectorAll('[data-fix-step]')],status=root.querySelector('[data-fix-status]'),nav=root.querySelector('nav'),retry=root.querySelector('[data-fix-retry]'),grid=root.querySelector('[data-fix-grid]'),more=root.querySelector('[data-fix-more]');
let rules,goal,need,products,matches=[],offset=0,step=1,controller,serial=0,budget='any',retryMode='rules';
const element=(tag,text)=>{const node=document.createElement(tag);if(text!==undefined)node.textContent=text;return node;};
const icon=name=>{
const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('class','ig-fix-goal-icon');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
for(const [tag,attrs] of rules.icons[name]||[]){const node=document.createElementNS('http://www.w3.org/2000/svg',tag);for(const [key,value] of Object.entries(attrs))node.setAttribute(key,value);svg.append(node);}
return svg;
};
const show=value=>{
step=value;panels.forEach(panel=>{panel.hidden=Number(panel.dataset.fixStep)!==value;});
nav.hidden=value===1;status.textContent='';retry.hidden=true;
panels.find(panel=>Number(panel.dataset.fixStep)===value).querySelector('h3').focus({preventScroll:true});
};
const cancel=()=>{serial++;controller?.abort();controller=null;root.removeAttribute('aria-busy');status.textContent='';retry.hidden=true;};
const loadRules=async()=>{
retryMode='rules';retry.hidden=true;status.textContent=labels.rulesLoading;
try{
const response=await fetch(root.dataset.fixRules,{credentials:'same-origin'});
if(!response.ok)throw Error('Rules unavailable');
const value=await response.json();
if(!Array.isArray(value.goals)||!value.goals.length)throw Error('Invalid rules');
rules=value;
const holder=root.querySelector('[data-fix-goals]');holder.replaceChildren();
for(const item of rules.goals){const button=element('button');button.type='button';button.dataset.fixGoal=item.id;button.append(icon(item.icon),element('span',item.label));holder.append(button);}
status.textContent='';
}catch(error){status.textContent=labels.loadError;retry.hidden=false;}
};
const chooseGoal=id=>{
cancel();goal=rules.goals.find(item=>item.id===id);need=null;
root.querySelector('[data-fix-goal-context]').textContent=goal.label;
const holder=root.querySelector('[data-fix-problems]');holder.replaceChildren();
for(const item of goal.needs){const button=element('button',item.label);button.type='button';button.dataset.fixNeed=item.id;holder.append(button);}
show(2);
};
const withinBudget=variant=>budget==='any'||budget==='under'&&variant.price<2500||budget==='mid'&&variant.price>=2500&&variant.price<=5000;
const buildMatches=()=>{
const reviewedIds=new Set(need.products.map(ref=>String(ref.id)));
const reviewedHandles=new Set(need.products.map(ref=>ref.handle));
const seen=new Set();
matches=products.filter(product=>reviewedIds.has(String(product.id))||reviewedHandles.has(product.handle)||product.purpose_verified===true&&product.purpose_tags?.includes('ig-purpose:'+need.id)).flatMap(product=>{
const variant=product.variants.find(variant=>withinBudget(variant)&&!(rules.excludedVariantIds||[]).includes(String(variant.id)));
const identity=product.title.toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
if(!variant||seen.has(identity))return [];
seen.add(identity);return [{product,variant}];
});
offset=0;
};
const render=()=>{
grid.replaceChildren();
root.querySelector('[data-fix-result-context]').textContent=need.label;
for(const {product,variant} of matches.slice(offset,offset+3)){
const card=element('article');card.dataset.fixCard='';
if(product.image){const image=element('img'),url=new URL(product.image,location.origin);if(url.protocol==='https:')image.src=url.href;image.alt=product.title;image.width=480;image.height=480;image.loading='lazy';card.append(image);}
card.append(element('h4',product.title));
if(variant.title&&variant.title!=='Default Title')card.append(element('p',variant.title));
const reason=element('p');reason.className='ig-fix-reason';reason.append(element('strong',labels.why+' '),document.createTextNode(need.reason));card.append(reason,element('strong',variant.money));
const link=element('a',labels.cta),url=new URL(product.url,location.origin);if(url.origin!==location.origin)continue;
url.searchParams.set('variant',String(variant.id));link.href=url.pathname+url.search;link.dataset.fixProduct='';card.append(link);grid.append(card);
}
root.querySelector('[data-fix-empty]').hidden=matches.length!==0;
root.querySelector('[data-fix-count]').textContent=matches.length?labels.count.replace('{from}',String(offset+1)).replace('{to}',String(Math.min(offset+3,matches.length))).replace('{count}',String(matches.length)):'';
more.hidden=offset+3>=matches.length;
};
const recommend=async()=>{
cancel();show(4);grid.replaceChildren();more.hidden=true;root.querySelector('[data-fix-empty]').hidden=true;root.querySelector('[data-fix-count]').textContent='';root.querySelector('[data-fix-result-context]').textContent=need.label;
if(products){buildMatches();render();return;}
const requestSerial=serial;controller=new AbortController();const signal=controller.signal;
retryMode='catalog';root.setAttribute('aria-busy','true');status.textContent=labels.loading;
const loaded=new Map();
try{
let pages=1;
for(let page=1;page<=pages;page++){
const route=(window.Shopify?.routes?.root||'/')+'collections/all';
const url=new URL(route,location.origin);url.searchParams.set('section_id',root.dataset.fixCatalogSection);url.searchParams.set('page',String(page));
const theme=new URLSearchParams(location.search).get('preview_theme_id');if(theme)url.searchParams.set('preview_theme_id',theme);
const response=await fetch(url,{signal,credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('Catalog unavailable');
const doc=new DOMParser().parseFromString(await response.text(),'text/html'),data=doc.querySelector('[data-fix-products]');if(!data)throw Error('Missing catalog data');
const batch=JSON.parse(data.textContent);if(!Array.isArray(batch.products)||!Number.isInteger(batch.pages)||batch.pages<0)throw Error('Invalid catalog data');
pages=Math.max(1,batch.pages);for(const product of batch.products)if(product.variants?.length)loaded.set(product.id,product);
}
if(signal.aborted||serial!==requestSerial)return;
products=[...loaded.values()].sort((a,b)=>Number(b.published)-Number(a.published)||a.title.localeCompare(b.title));
controller=null;root.removeAttribute('aria-busy');status.textContent='';buildMatches();render();
}catch(error){if(signal.aborted||serial!==requestSerial)return;controller=null;root.removeAttribute('aria-busy');status.textContent=labels.loadError;retry.hidden=false;}
};
root.addEventListener('click',event=>{
const button=event.target.closest?.('button');if(!button||!root.contains(button))return;
if(button.hasAttribute('data-fix-goal'))chooseGoal(button.dataset.fixGoal);
else if(button.hasAttribute('data-fix-need')){cancel();need=goal.needs.find(item=>item.id===button.dataset.fixNeed);root.querySelector('[data-fix-problem-context]').textContent=need.label;show(3);}
else if(button.hasAttribute('data-fix-budget')){budget=button.dataset.fixBudget;recommend();}
else if(button.hasAttribute('data-fix-more')){offset+=3;render();show(4);panels.find(panel=>panel.dataset.fixStep==='4').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
else if(button.hasAttribute('data-fix-back')){cancel();show(Math.max(1,step-1));}
else if(button.hasAttribute('data-fix-restart')){cancel();goal=null;need=null;matches=[];grid.replaceChildren();show(1);}
else if(button.hasAttribute('data-fix-retry')){if(retryMode==='rules')loadRules();else recommend();}
});
const details=root.querySelector('details');
details.addEventListener('toggle',()=>{if(details.open&&!rules)loadRules();});
if(details.open)loadRules();
})();